import { useId as useVueId } from 'vue'

/** Stable per-app id for label/aria wiring, with an optional semantic prefix. */
export function useId(prefix = 'ui'): string {
  return `${prefix}-${useVueId()}`
}
